/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import type { IconName } from '@/components/Icon';

export interface ResourceLink {
  label: string;
  href: string;
  description: string;
  icon: IconName;
}

export interface ResourceGroup {
  title: string;
  description: string;
  links: ResourceLink[];
}

export const RESOURCE_GROUPS: ResourceGroup[] = [
  {
    title: 'resources.groups.resources.title',
    description: 'resources.groups.resources.description',
    links: [
      {
        label: 'resources.links.techLink.label',
        href: 'https://gm-techlink.com/',
        description: 'resources.links.techLink.description',
        icon: 'spark',
      },
      {
        label: 'resources.links.serviceInfo.label',
        href: 'https://service-info.gm.com/gsi/login.do',
        description: 'resources.links.serviceInfo.description',
        icon: 'book',
      },
    ],
  },
];

export const RESOURCE_LINKS = RESOURCE_GROUPS.flatMap((group) => group.links);
